<template>
  <v-card
    v-if="viewData"
    flat
  >
    <v-card-title class="py-0 px-0">
      <v-toolbar
        :height="$vuetify.breakpoint.xsOnly ? 44 : 60"
        class="filter-toolbar"
        flat
      >
        <v-btn
          v-if="userCanAdd"
          :color="$t('Marketing.Push.ListView.Button.Add.Color')"
          :icon="$vuetify.breakpoint.xsOnly"
          class="elevation-0 ma-1"
          text
          @click="showAddPushCampaignDialog"
        >
          <v-icon :left="$vuetify.breakpoint.smAndUp">
            {{ $t('Marketing.Push.ListView.Button.Add.Icon') }}
          </v-icon>&nbsp;
          <span v-if="$vuetify.breakpoint.smAndUp">{{ $t('Marketing.Push.ListView.Button.Add.Title') }}</span>
        </v-btn>

        <v-spacer />

        <filter-search v-model="dataTable.search.terms" />
      </v-toolbar>
    </v-card-title>

    <v-container
      class="pa-0"
      fluid
    >
      <v-row>
        <v-col cols="12">
          <v-data-table
            :footer-props="dataTable.footerProps"
            :headers="dataTableHeaders"
            :height="dataTable.resize.bodyHeight"
            :items="dataTable.data"
            :loading="dataTable.loading"
            :loading-text="dataTable.text.loadingText"
            :no-data-text="dataTable.text.noDataText"
            :no-results-text="dataTable.text.noResultsText"
            :options.sync="dataTable.options"
            :search="dataTable.search.terms"
            :server-items-length="dataTable.total"
            fixed-header
            item-key="Id"
          >
            <template #[`item.id`]="{item}">
              {{ item.Id }}
            </template>

            <template #[`item.name`]="{item}">
              {{ item.Name }}
            </template>

            <template #[`item.customer_groups`]="{item}">
              <v-chip
                label
                small
              >
                {{ item.Groups.length }}
              </v-chip>
            </template>

            <template #[`item.status`]="{item}">
              <v-chip
                label
                small
              >
                {{ item.Status }}
              </v-chip>
            </template>

            <template #[`item.total`]="{item}">
              <v-chip
                label
                small
              >
                {{ formatDecimal($i18n.locale, item.Total, 0) }}
              </v-chip>
            </template>

            <template #[`item.delivered`]="{item}">
              <v-chip
                label
                small
              >
                {{ formatDecimal($i18n.locale, item.Delivered, 0) }}
              </v-chip>
            </template>

            <template #[`item.ctr`]="{item}">
              {{ item.Ctr }}
            </template>

            <template #[`item.send_at`]="{item}">
              {{ item.SendAt }}
            </template>

            <template #[`item.created_at`]="{item}">
              {{ item.CreatedAt }}
            </template>

            <!--
            <template #[`item.actions`]="{item}">
              <v-tooltip
                v-if="userCanManage"
                :color="$t('Marketing.Push.ListView.Button.Edit.Color')"
                :open-delay="1000"
                left
              >
                <template #activator="{on}">
                  <v-btn
                    v-if="userCanManage"
                    :class="$t('Marketing.Push.ListView.Button.Edit.Color')"
                    :small="$vuetify.breakpoint.xsOnly"
                    class="elevation-2 ma-0"
                    dark
                    icon
                    @click="showCouponEditDialog(item)"
                    v-on="on"
                  >
                    <v-icon>{{ $t('Marketing.Push.ListView.Button.Edit.Icon') }}</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('Marketing.Push.ListView.Button.Edit.Title') }}</span>
              </v-tooltip>
            </template>
            -->

            <template #no-data>
              <v-data-table-no-data
                :button-callback="showAddPushCampaignDialog"
                :no-data-obj="$t('Marketing.Push.ListView.Table.NoData')"
              />
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import AppData from '@/mixins/appdata.js'
import Auth from '@/mixins/auth.js'
import DataTable from '@/mixins/data-table/dataTable.js'
import FilterSearch from '@/components/common/filter/FilterSearch.vue'
import {formatDecimal} from '@/lib/currency/currency.js'
import VDataTableNoData from '@/components/common/data-table/VDataTableNoData.vue'

export default {
  Name      : 'Push',
  components: {
    VDataTableNoData,
    FilterSearch
  },
  directives: {},
  mixins    : [AppData, Auth, DataTable],
  data() {
    return {
      addPushCampaignDialog: false,
      dataTable            : {
        socketCommand: {
          list  : window.SocketCommand.Marketing.Push.All,
          save  : window.SocketCommand.Marketing.Push.Save,
          delete: window.SocketCommand.Marketing.Push.Delete
        },
        options: {
          defaultSortBy: 'id',
          sortBy       : ['id'],
          sortDesc     : [true]
        },
        rejectHeaders: {
          xsOnly   : [],
          smAndDown: [],
          mdAndDown: [],
          lgAndDown: [],
          xlAndDown: []
        },
        headers: [
          {
            text     : this.$t('Marketing.Push.ListView.Table.Headers.Id'),
            value    : 'id',
            align    : 'right',
            sortable : true,
            cellClass: 'text-caption'
          },
          {
            text     : this.$t('Marketing.Push.ListView.Table.Headers.Name'),
            value    : 'name',
            align    : 'left',
            sortable : true,
            cellClass: 'text-caption'
          },
          {
            text     : this.$t('Marketing.Push.ListView.Table.Headers.Groups'),
            value    : 'customer_groups',
            align    : 'center',
            sortable : false,
            cellClass: 'text-caption'
          },
          {
            text     : this.$t('Marketing.Push.ListView.Table.Headers.Status'),
            value    : 'status',
            align    : 'center',
            sortable : true,
            cellClass: 'text-caption'
          },
          {
            text     : this.$t('Marketing.Push.ListView.Table.Headers.Total'),
            value    : 'total',
            align    : 'center',
            sortable : true,
            cellClass: 'text-caption'
          },
          {
            text     : this.$t('Marketing.Push.ListView.Table.Headers.Delivered'),
            value    : 'delivered',
            align    : 'center',
            sortable : true,
            cellClass: 'text-caption'
          },
          {
            text     : this.$t('Marketing.Push.ListView.Table.Headers.Ctr'),
            value    : 'ctr',
            align    : 'center',
            sortable : true,
            cellClass: 'text-caption'
          },
          {
            text     : this.$t('Marketing.Push.ListView.Table.Headers.SendAt'),
            value    : 'send_at',
            align    : 'center',
            sortable : true,
            cellClass: 'text-caption'
          },
          {
            text     : this.$t('Marketing.Push.ListView.Table.Headers.CreatedAt'),
            value    : 'created_at',
            align    : 'center',
            sortable : true,
            cellClass: 'text-caption'
          },
          {
            text     : this.$t('Marketing.Push.ListView.Table.Headers.Actions'),
            value    : 'actions',
            align    : 'right',
            sortable : false,
            cellClass: 'text-caption px-2',
            width    : 40
          }
        ]
      }
    }
  },
  computed: {},
  watch   : {},
  created() {
  },
  mounted() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  methods: {
    formatDecimal,

    showAddPushCampaignDialog() {
      this.addPushCampaignDialog = true
    }
  }
}
</script>

<style scoped>
:deep(.filter-toolbar .v-toolbar__content) {
  padding: 0 6px;
}

:deep(.v-input--selection-controls.v-input--switch) {
  display: inline-block;
  position: relative !important;
  /*width    : 75px !important;*/
}

:deep(.v-input--selection-controls.v-input--switch label) {
  font-size: 12px !important;
  padding-right: 0;
  margin: 0;
}

:deep(.v-data-table > .v-data-table__wrapper > table:has(tbody tr:first-child.v-data-table__empty-wrapper)) {
  width: 100%;
  height: 100%;
  border-spacing: 0;
}
</style>
